import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

export type DashboardStats = {
  session_pool: number;
  session_pool_week: number;
  current_students: number;
  students_active: number;
  minutes_completed: number;
  taught_students: number;
  target_completed: number;
  sessions_remaining: number;
};

export type DashboardScheduleItem = {
  time: string;
  duration: number;
  student_name: string;
  avatar: string;
  plan_title: string;
  status: string;
  join_link: string;
};

export type DashboardResponse = {
  stats: DashboardStats;
  schedule: DashboardScheduleItem[];
};

type DashboardState = {
  loading: boolean;
  data: DashboardResponse | null;
  error: boolean;
  errorMessage: string;
};

const initialState: DashboardState = {
  loading: false,
  data: null,
  error: false,
  errorMessage: '',
};

export const getDashboard = createAsyncThunk<DashboardResponse>(
  'getDashboard',
  async () => {
    const { data } = await api.get('/api/coaches/me/dashboard');
    return data as DashboardResponse;
  }
);

const getDashboardSlice = createSlice({
  name: 'getDashboard',
  initialState,
  reducers: {
    resetDashboard: (state) => {
      state.loading = false;
      state.data = null;
      state.error = false;
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDashboard.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(getDashboard.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(getDashboard.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to load dashboard data.';
    });
  },
});

export const { resetDashboard } = getDashboardSlice.actions;
export default getDashboardSlice.reducer;
